import { useMemo } from "react";
/**
 * Custom hook to transform the raw click timeline data objects into chart-compatible arrays.
 *
 * @param {ClickTimelineRawData | null} raw - The raw data object returned by useClickTimeline.
 * @returns {NormalizedTimeline} An object containing hourly, daily, and monthly data arrays.
 */
function useNormalizedTimeline(raw) {
    return useMemo(() => {
        if (!raw) return { hourly: [], daily: [], monthly: [] , minutes: []};

        const objToArray = (obj) =>
            Object.entries(obj || {}).map(([k, v]) => ({
                date: String(k),
                rate: Number(v) || 0,
            }));

        const hourly = objToArray(raw.hourlyData);
        const daily = objToArray(raw.dailyData);
        const monthly = objToArray(raw.monthlyData);
        const minutes = objToArray(raw.minutesData);

        return { hourly, daily, monthly , minutes};
    }, [raw]);
}

export default useNormalizedTimeline;